import { Component, NgModule, OnInit } from '@angular/core'
import { UserService } from '@service/user/user.service'
import { messages } from '@configuration/messages'
import { FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms'
import { SharedModule } from 'src/app/shared.module'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { MobileService } from '@service/mobile.service'

function password_confirmation(group: FormGroup): ValidationErrors | null {
  const password = group.value.password
  const password_confirmation = group.value.password_confirmation
  if (password != password_confirmation) {
    return { passwordsDontMatch: true }
  }
  return null
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public success: boolean = false
  public fail: boolean = false

  public loading = false

  public messages = messages

  public form: FormGroup = new FormGroup(
    {
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      password_confirmation: new FormControl('', [Validators.required, Validators.minLength(6)]),
    },
    {
      validators: [password_confirmation],
    }
  )

  public submitted: boolean = false

  constructor(
    private UserService: UserService,
    private ActivatedRoute: ActivatedRoute,
    public MobileService: MobileService,
  ) { }

  ngOnInit() {
  }

  public send() {

    this.success = false
    this.fail = false

    this.submitted = true

    if (this.form.invalid)
      return

    let id = this.ActivatedRoute.snapshot.paramMap.get('id')
    let token = this.ActivatedRoute.snapshot.paramMap.get('token')

    this.loading = true
    this.UserService.sendPasswordResetRequest(this.form.controls.password.value, token, id)
      .then(() => {
        this.success = true
      })
      .catch(() => {
        this.fail = true
      })
      .finally(() => {
        this.loading = false
      })
  }

}

@NgModule({
  declarations: [
    ResetPasswordComponent
  ],
  imports: [
    SharedModule,

    RouterModule.forChild([
      {
        path: "",
        component: ResetPasswordComponent
      },
    ]),
  ],
  exports: [
    ResetPasswordComponent,

    SharedModule,
  ]
})
export class ResetPasswordComponentModule { }